import rawConfig from './deferredEventBatching.json'

export type DeferredEventActionKey =
  | 'WORKSPACE_ACTIVITY'
  | 'UPLOAD_HUB_ACTIVITY'
  | `CONTRIBUTION:${'TASK' | 'CHECKLIST'}`
  | `EXPERIENCE:${string}`
  | 'INTEGRATION_GATE_HIT'
  | 'INTEGRATION_MISSING'

export type DeferredEventBatchingConfig = {
  enabled: boolean
  flushIntervalMs: number
  minimumBatchSize: number
  maxWaitMs: number
  maxBatchSize: number
  actions: Partial<Record<DeferredEventActionKey, { enabled: boolean }>>
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export const normalizeDeferredEventBatchingConfig = (value: unknown): DeferredEventBatchingConfig => {
  const config = isRecord(value) ? value : {}
  const actions = isRecord(config.actions) ? config.actions : {}
  return {
    enabled: config.enabled !== false,
    flushIntervalMs: Math.max(1_000, Math.min(60_000, Number(config.flushIntervalMs) || 10_000)),
    minimumBatchSize: Math.max(1, Math.min(200, Math.floor(Number(config.minimumBatchSize) || 10))),
    maxWaitMs: Math.max(0, Math.min(24 * 60 * 60 * 1000, Number(config.maxWaitMs) || 60_000)),
    maxBatchSize: Math.max(1, Math.min(200, Math.floor(Number(config.maxBatchSize) || 50))),
    actions: Object.fromEntries(Object.entries(actions).flatMap(([key, entry]) => {
      if (!isRecord(entry)) return []
      return [[key, { enabled: entry.enabled === true }]]
    })) as DeferredEventBatchingConfig['actions'],
  }
}

export const deferredEventBatchingConfig = normalizeDeferredEventBatchingConfig(rawConfig)

export const isDeferredEventActionEnabled = (
  actionKey: DeferredEventActionKey,
  config: DeferredEventBatchingConfig = deferredEventBatchingConfig,
): boolean => config.enabled === true && config.actions[actionKey]?.enabled === true
